module.exports = __webpack_public_path__ + "img/6.809a0c31.jpg";